module.exports = true;



//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/core-js/library/modules/_library.js
// module id = 130
// module chunks = 20